"use strict";

module.exports = function (column) {
  var c = this.sortable(column) ? 'VueTables__sortable ' : '';
  c += this.columnClass(column);
  return c;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/sortable-class.js
// module id = 2638
// module chunks = 0